import { useState, useMemo, ReactNode } from 'react';
import VocalInterfaceContext from './VocalInterfaceContext';

interface VocalInterfaceProviderProps {
  children: ReactNode;
};

function VocalInterfaceProvider({ children }: VocalInterfaceProviderProps) {
  const [ currentText, setCurrentText ] = useState<string>('');
  const [ isVocalInterface, setIsVocalInterface ] = useState<boolean>(false);

  const vocalInterfaceContextValues = useMemo(() => ({
    currentText,
    setCurrentText,
    isVocalInterface,
    setIsVocalInterface
  }), [currentText, isVocalInterface]);  
  
  return (
    <VocalInterfaceContext.Provider value={ vocalInterfaceContextValues }>
      { children }
    </VocalInterfaceContext.Provider>
  );
};

export default VocalInterfaceProvider;